/* eslint-disable */
import * as shared from '../shared';

googletag.cmd.push(function () {
  // institution_search_result_top
  googletag.defineSlot(
    '/21678620621/medicalnote_hospital_search_top_20181003',
    [[728, 135], [728, 90]],
    'div-gpt-ad-1548833255835-0'
  ).addService(googletag.pubads());

  // institution_search_result_middle
  googletag.defineSlot(
    '/21678620621/medicalnote_hospital_search_feed1_20210330',
    [[728, 135], 'fluid', [728, 90]],
    'div-gpt-ad-1617205062503-0'
  ).addService(googletag.pubads());

  // institution_search_result_leftup
  googletag.defineSlot(
    '/21678620621/medicalnote_hospital_search_right_20181003',
    [[300, 600], [160, 600], [230, 675]],
    'div-gpt-ad-1538558192829-0'
  ).addService(googletag.pubads());

  // institution_search_result_bottom
  googletag.defineSlot(
    '/21678620621/medicalnote_hospital_search_bottom_20181003',
    [[728, 90], [728, 135]],
    'div-gpt-ad-1548834292344-0'
  ).addService(googletag.pubads());

  shared.setDiseaseKeyValue();
  shared.setSymptomKeyValue();
  shared.setContentTypeKeyValue();
  shared.setHospitalDepartmentKeyValue();
  shared.setEnvKeyValue();
  shared.setAdTagKeyValue();
  shared.setPathKeyValue();
  shared.setDoctorKeyValue();

  if (!shared.isMobile()) googletag.pubads().enableSingleRequest();
  googletag.pubads().collapseEmptyDivs();
  googletag.enableServices();
});
/* eslint-enable */
